import { FC, Fragment, useEffect, useRef, useState } from "react";
import {
  Benefit as BenefitType,
  BenefitsSkinProps } from
"@commons-monorepo/index";
import styles from "./benefits-3.module.css";
import Slider from "react-slick";
import WidgetContainer from "../../../widget-container";

const Benefits3: FC<BenefitsSkinProps> = ({
  benefits,
  highLight,
  className
}) => {
  const sliderRef = useRef<Slider>(null);
  const [isMobile, setIsMobile] = useState(false);

  const settings = () => {
    return {
      centerMode: true,
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      speed: 400,
      dots: true,
      arrows: false,
      centerPadding: "0px"
    };
  };

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  const Benefit: FC<{benefit: BenefitType;}> = ({ benefit }) => {
    return (
      <article className={styles.benefit3}>
        <figure className={styles.icon}>
          <img loading={"lazy"} src={benefit.image} alt={benefit.title} />
        </figure>
        <div className={styles.info}>
          <h3 className={styles.title}>{benefit.title}</h3>
          <div className={styles.description}>
            <p>{benefit.description}</p>
          </div>
        </div>
      </article>);

  };

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight={!!highLight}>

      <section
        className={`${styles.benefits3} ${
        isMobile ? styles.benefits3Mobile : ""
        } ${className || ""}`}
        aria-label='benefits-container'>

        <div className={`${styles.benefits3Container} ${styles.benefit3Grid}`}>
          {isMobile ?
          <Slider ref={sliderRef} {...settings()}>
              {benefits.map((benefit, index) =>
            <Benefit benefit={benefit} key={`benefit-${index}`} />
            )}
            </Slider> :

          <>
              {benefits.map((benefit, index) =>
            <Fragment key={`benefit-${index}`}>
                  {index !== 0 &&
              <hr
                className={styles.separator}
                aria-label='benefits-separator' />}


                  <Benefit benefit={benefit} />
                </Fragment>
            )}
            </>}

        </div>
      </section>
    </WidgetContainer>);

};

export default Benefits3;